import React from 'react'
import PhoneInput from 'react-phone-number-input'

// styles
import { Wrapper, PhoneNumberInputLabel } from './styles'
import { Error, RequiredTag, SubLabel, Success } from '../InputLabels/InputLabels'

// external styles
import 'react-phone-number-input/style.css'

const PhoneNumberInput = ({
  field,
  disabled,
  form: { errors, touched, setFieldValue, handleBlur, ...formProps },
  label,
  subLabel,
  success,
  requiredField,
  fullWidth,
  ...props
}) => {
  const hasError = !!errors[field.name]

  return (
    <Wrapper
      disabled={disabled}
      hasError={hasError}
      touched={!!touched[field.name]}
      requiredField={requiredField}
      fullWidth={fullWidth}
    >
      {label && (
        <PhoneNumberInputLabel htmlFor={field.name}>
          {label}
          <RequiredTag hasError={hasError} label={label} requiredField={requiredField} />
        </PhoneNumberInputLabel>
      )}

      {subLabel && <SubLabel>{subLabel}</SubLabel>}

      <PhoneInput
        {...field}
        {...props}
        disabled={disabled}
        defaultCountry="ZA"
        international={false}
        onBlur={() => handleBlur(field.name)}
        onChange={value => {
          setFieldValue(field.name, value)

          if (value && props.validateOnChange) {
            props.validateField({ value: value })
          }

          if (formProps.handleChange) {
            formProps.handleChange(value || '')
          }
        }}
      />
      {success && touched[field.name] && !errors[field.name] && <Success>{success}</Success>}
      {errors[field.name] && <Error>{errors[field.name]}</Error>}
    </Wrapper>
  )
}

export default PhoneNumberInput
